import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FulleStockService } from 'src/app/services/api/fulle/fulle-stock/fulle-stock.service';
@Component({
  selector: 'app-alert-stock',
  templateUrl: './alert-stock.component.html',
  styleUrls: ['./alert-stock.component.css']
})
export class AlertStockComponent implements OnInit {
  innerHeight: number = window.innerHeight;
  negativeStock: any;
  /**
   * Image par default si aucune image
   */
  default_prod: string = "https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png";


  @ViewChild(MatSort) sort: MatSort |any;


  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();


  displayedColumns: string[] = ['name', 'count'];

  data: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data :any,
    public dialogRef: MatDialogRef<AlertStockComponent>,
    private stockApi: FulleStockService,

  ) {
    this.data = data;

  }

  ngOnInit() {
    setTimeout(() => {
      this.dataSource.data = this.data;
      this.dataSource.sort = this.sort;
    });
  }

  closeDial() {
    this.dialogRef.close();
    this.stockApi.setArrayPop([]);
  }
}
